import { Box, ListItemText, Tab, Tabs, Typography, useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { IDbTaskExecResult, IDbTaskExecResultStatus } from "bets.oddprovider.lib.common.ts/models"
import { FormItemStyled, FormStyled, TableObjWrapperComponent } from "fwork.react.apptemplate"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { MdCheck as MdCheckIcon, MdError as MdErrorIcon } from "react-icons/md"
import { IDbTaskHistory } from "."
import { DEFAULTGAP } from "../../globals"

export interface DbTaskHistoryComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  data: IDbTaskExecResult[]
}

export const DbTaskHistoryComponent = (props: DbTaskHistoryComponentProps) => {
  const { data, ...rest } = props
  const [currExec, setCurrExec] = useState<IDbTaskExecResult | undefined>(data[0])
  const [currTab, setCurrTab] = useState<number>(0)

  useEffect(() => {
    setCurrExec(data[0])
  }, [data])

  return <div
    {...rest}

    style={{
      display: 'flex',
      flexDirection: 'column',
      borderLeft: '1px solid #ECECED',
      ...props.style,
    }}
  >
    <Tabs
      value={currTab}
      onChange={(event: React.SyntheticEvent, newValue: number) => {
        setCurrTab(newValue)
      }}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      style={{
        borderBottom: '1px solid #ECECED',
      }}
    >
      {props?.data?.map((exec, idx) =>
        <Tab
          icon={exec.status == IDbTaskExecResultStatus.waiting ? <MdErrorIcon size={20} /> :
            exec.status == IDbTaskExecResultStatus.success ? <MdCheckIcon size={20} /> : <MdErrorIcon size={20} />}
          value={idx}
          iconPosition='start'
          key={idx}
          label={exec.db_name}
          onClick={() => setCurrExec(exec)}
          style={{
            color: exec.status == IDbTaskExecResultStatus.waiting ? '#1565C0' :
              exec.status == IDbTaskExecResultStatus.success ? 'green' : 'orangered'
          }}
        />
      )}
    </Tabs>
    {currExec && data.indexOf(currExec) !== -1 ? <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <pre>{JSON.stringify(currExec?.msg, null, 3)}</pre>
        {currExec.result_set?.length ? <TableObjWrapperComponent obj={currExec.result_set} quoteStr={false} /> : <></>}
      </FormItemStyled>
    </FormStyled> : <></>}
  </div>
}

export interface DbTaskHistoriesComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  data: IDbTaskHistory[]
}

export const DbTaskHistoriesComponent = (props: DbTaskHistoriesComponentProps) => {
  const { data, ...rest } = props
  const [currHistory, setCurrHistory] = useState<IDbTaskExecResult[] | undefined>()
  const [currTab, setCurrTab] = useState<number>(0)

  useEffect(() => {
    setCurrHistory(data[0].dbTaskExecResult)
  }, [data])

  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('md'))

  return <div
    aria-label="DbTaskHistoriesComponent"
    {...rest}

    style={{
      display: 'flex',
      ...props.style,
    }}
  >
    <Box
    aria-label="DbTaskHistoriesComponent-Box"
      sx={{
        width: '100%',
        display: 'flex',
        flexWrap: { xs: 'wrap', md: 'nowrap' },
      }}
    >
      <Tabs
        style={{
          overflow: smallScreen ? 'auto' : 'visible'
        }}
        sx={{
          order: { xs: 1, md: 0 }
        }}
        TabIndicatorProps={{
          sx: { display: { xs: 'initial', md: 'none' } }
        }}
        value={currTab}
        onChange={(event: React.SyntheticEvent, newValue: number) => {
          setCurrTab(newValue)
        }}
        variant="scrollable"
        orientation={smallScreen ? "horizontal" : "vertical"}
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {data?.map((history, idx) =>
          <Tab
            icon={
              // WAIT
              history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.waiting).length ?
                <span style={{
                  background: '#1565C0',
                  color: 'white',
                  borderRadius: '100%',
                  width: 20,
                  height: 20,
                  minWidth: 20,
                  minHeight: 20,
                  fontSize: 'small',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  {history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.waiting).length}
                </span> :
                // ERROR
                history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.error).length ?
                  <span style={{
                    background: 'orangered',
                    color: 'white',
                    borderRadius: '100%',
                    width: 20,
                    height: 20,
                    minWidth: 20,
                    minHeight: 20,
                    fontSize: 'small',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    {history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.error).length}
                  </span>
                  :
                  // SUCCESS
                  <MdCheckIcon size={20} style={{ minWidth: 20 }} />}

            iconPosition='start'

            style={{
              color:
                history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.waiting).length ?
                  '#1565C0' :
                  history.dbTaskExecResult.filter(h => h.status == IDbTaskExecResultStatus.error).length ?
                    'orangered' :
                    'green',
              paddingInline: 20
            }}

            key={idx}

            label={<ListItemText
              style={{
                textAlign: 'left'
              }}
              primary={<span style={{
                whiteSpace: 'nowrap',
              }}>{`${history.taskName} ${idx + 1}`}</span>}
              secondary={<span>{moment(history.date).format('DD/MM/yy hh:mm').toString()}</span>}
            />}

            onClick={() => setCurrHistory(history.dbTaskExecResult)} />
        )}
      </Tabs>
      {currHistory ? <DbTaskHistoryComponent style={{
        width: '100%',
        overflow: 'hidden'
      }} data={currHistory} /> : <></>}
    </Box>
  </div>
}